export const HIDE_ACCOUNT_ACTIONS_PARAM = 'hideAccountActions';

/**
 * 判断路由查询参数是否要求隐藏账号操作入口。
 * 支持 ?hideAccountActions、?hideAccountActions=1 和 ?hideAccountActions=true。
 */
export function shouldHideAccountActions(query = {}) {
  if (!Object.prototype.hasOwnProperty.call(query, HIDE_ACCOUNT_ACTIONS_PARAM)) {
    return false;
  }

  const rawValue = query[HIDE_ACCOUNT_ACTIONS_PARAM];
  const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;

  return value == null || value === '' || value === '1' ||
    (typeof value === 'string' && value.toLowerCase() === 'true');
}
